
import {mapActions, mapState} from "vuex";
import {validateCpf} from "@/helpers/cpf.validator";
import GlobalStore from "@/store/modules/global";
import {throwError} from "rxjs";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import VueRecaptcha from "vue-recaptcha";
import {VUE_APP_RECAPTCHA_KEY} from "@/commons/config";
import SolicitacaoService from "@/services/sie-pedidos/solicitacao.service";

const actions = mapActions('siePedidos', ['setFormStep', 'setCPF', 'setDadosFormSolicitacao', 'setEndereco', 'clearDadosFormSolicitacao']);
const state = mapState('siePedidos', ['form'])
export default {
  name: "FormConsultaCPF",
  components: {VueRecaptcha},
  data() {
    return{
      siteKey: VUE_APP_RECAPTCHA_KEY,
      rule: value => !!validateCpf(value) || "CPF inválido!",
      rules: {
        required: (value) => !!value || "Esse campo deve ser preenchido!",
      }
    }
  },
  computed: {
    ...state
  },
  watch: {
    'form.cpf': function(newValue, oldValue) {
      if(this.form.tipoSolicitacaoId === 1){
        const isValid = this.$refs.form.validate();
        const cpfFormat = FunctionsCommuns.removeFormat(newValue)
        if(this.form.cpf && isValid && newValue && newValue !== oldValue && FunctionsCommuns.validateCPF(newValue)) {
            SolicitacaoService.getStatusSolicitacao(cpfFormat, this.form.tipoSolicitacaoId).subscribe(
              response =>{
                const result = response['result']?.cpf ? response['result'] : {cpf: newValue}
                this.setCPF(newValue)
                this.setFormStep(3)
                this.setDadosFormSolicitacao({aluno: result})
              },
              error => {
                throwError(error);
                this.loading = false;
              }
            )
          }
      }
    }
  },
  mounted() {
    this.setEndereco({});
    this.clearDadosFormSolicitacao();
  },
  methods: {
    ...actions,
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit(){
      const isValid = this.$refs.form.validate();
      const cpfFormat = FunctionsCommuns.removeFormat(this.form.cpf)
      if(this.form.cpf && isValid){
        SolicitacaoService.segundaVia(cpfFormat).subscribe(
          response =>{
            GlobalStore.setSnackBar({
              show: true,
              message: response['message'],
              type: "success"
            })
            this.setFormStep(4)
          },
          error => {
            throwError(error);
            this.loading = false;
          }
        )
      }
    },
    voltar(){
      this.setFormStep(1)
      this.setCPF(null)
    }
  }
}
